import { useTranslation } from 'react-i18next';
import Heading from 'components/Home/Heading';
import useExpanded from 'lib/hooks/useExpanded';
import { Link, Button } from 'components/Home/LinkGridShared';
import popularSearchesCSS from '../styles/Home/PopularSearches';

const DEFAULT_NUM_OF_LISTINGS = 30;
const SEARCH_URLS = Object.freeze([
  { title: 'Acura MDX', url: '/acura-mdx' },
  { title: 'Bmw X5', url: '/bmw-x5' },
  { title: 'Buick Enclave', url: '/buick-enclave' },
  { title: 'Cadillac Escalade', url: '/cadillac-escalade' },
  { title: 'Chevrolet Camaro', url: '/chevrolet-camaro' },
  { title: 'Chevrolet Colorado', url: '/chevrolet-colorado' },
  { title: 'Chevrolet Corvette', url: '/chevrolet-corvette' },
  { title: 'Chevrolet Equinox', url: '/chevrolet-equinox' },
  { title: 'Chevrolet Impala', url: '/chevrolet-impala' },
  { title: 'Chevrolet Malibu', url: '/chevrolet-malibu' },
  { title: 'Chevrolet Silverado 1500', url: '/chevrolet-silverado+1500' },
  { title: 'Chevrolet Suburban', url: '/chevrolet-suburban' },
  { title: 'Chevrolet Tahoe', url: '/chevrolet-tahoe' },
  { title: 'Chevrolet Traverse', url: '/chevrolet-traverse' },
  { title: 'Chrysler 300', url: '/chrysler-300' },
  { title: 'Dodge Challenger', url: '/dodge-challenger' },
  { title: 'Dodge Charger', url: '/dodge-charger' },
  { title: 'Dodge Durango', url: '/dodge-durango' },
  { title: 'Dodge Ram-1500', url: '/dodge-ram+pickup+1500' },
  { title: 'Ford Edge', url: '/ford-edge' },
  { title: 'Ford Escape', url: '/ford-escape' },
  { title: 'Ford Expedition', url: '/ford-expedition' },
  { title: 'Ford Explorer', url: '/ford-explorer' },
  { title: 'Ford F-150', url: '/ford-f+150' },
  { title: 'Ford F-250', url: '/ford-f+250' },
  { title: 'Ford Mustang', url: '/ford-mustang' },
  { title: 'Ford Ranger', url: '/ford-ranger' },
  { title: 'Gmc Acadia', url: '/gmc-acadia' },
  { title: 'Gmc Yukon', url: '/gmc-yukon' },
  { title: 'Honda Accord', url: '/honda-accord' },
  { title: 'Honda Civic', url: '/honda-civic' },
  { title: 'Honda CR-V', url: '/honda-cr+v' },
  { title: 'Honda Odyssey', url: '/honda-odyssey' },
  { title: 'Honda Pilot', url: '/honda-pilot' },
  { title: 'Jeep Cherokee', url: '/jeep-cherokee' },
  { title: 'Jeep Grand Cherokee', url: '/jeep-grand+cherokee' },
  { title: 'Jeep Wrangler', url: '/jeep-wrangler' },
  { title: 'Kia Sorento', url: '/kia-sorento' },
  { title: 'Land Rover Range Rover', url: '/land+rover-range+rover' },
  { title: 'Mini Convertible', url: '/mini-convertible' },
  { title: 'Mini Cooper', url: '/mini-cooper' },
  { title: 'Nissan Altima', url: '/nissan-altima' },
  { title: 'Nissan Rogue', url: '/nissan-rogue' },
  { title: 'Porsche 911', url: '/porsche-911' },
  { title: 'Subaru Forester', url: '/subaru-forester' },
  { title: 'Subaru Outback', url: '/subaru-outback' },
  { title: 'Subaru Wrx', url: '/subaru-impreza+wrx' },
  { title: 'Toyota 4Runner', url: '/toyota-4runner' },
  { title: 'Toyota Camry', url: '/toyota-camry' },
  { title: 'Toyota Corolla', url: '/toyota-corolla' },
  { title: 'Toyota Highlander', url: '/toyota-highlander' },
  { title: 'Toyota Land Cruiser', url: '/toyota-land+cruiser' },
  { title: 'Toyota Prius', url: '/toyota-prius' },
  { title: 'Toyota Rav4', url: '/toyota-rav4' },
  { title: 'Toyota Sienna', url: '/toyota-sienna' },
  { title: 'Toyota Tacoma', url: '/toyota-tacoma' },
  { title: 'Toyota Tundra', url: '/toyota-tundra' },
  { title: 'Volkswagen Beetle', url: '/volkswagen-beetle' },
  { title: 'Volkswagen Golf', url: '/volkswagen-golf' },
  { title: 'Volkswagen Jetta', url: '/volkswagen-jetta' },
]);

export default function PopularSearches() {
  const [expanded, topRef, toggleExpanded] = useExpanded();
  const listSize = expanded ? SEARCH_URLS.length : DEFAULT_NUM_OF_LISTINGS;
  const { t } = useTranslation();

  return (
    <div className="container" ref={topRef}>
      <Heading title={t('home.popularSearch.title')} />
      <div className="links" data-testid="links">
        {SEARCH_URLS.slice(0, listSize).map(({ title, url }) => (
          <Link key={url} url={url} section={'featured_popular'}>
            {title}
          </Link>
        ))}
      </div>
      <Button
        expanded={expanded}
        onClick={toggleExpanded}
        section={'featured_popular_show'}
      />
      <style jsx>{popularSearchesCSS}</style>
    </div>
  );
}
